import { Protocol } from '@studio/models/audio';
import { Filter } from './types.js';
import { Lang } from '#~/audio/index.js';
import type { Discovery$Audio } from '#~/device/discovery/index.js';

/** Device filter definitions. */
export const Filters: Record<
  Filter,
  Readonly<{
    /** Filter label. */
    label: string;

    /** Matching function. */
    matches: (µ: Discovery$Audio) => boolean;
  }>
> = Object.freeze({
  [Filter.All]: {
    label: 'All connections',
    matches(): boolean {
      return true;
    }
  },

  [Filter.Local]: {
    label: Lang.protocol[Protocol.Local],
    matches({ audio }: Discovery$Audio): boolean {
      return audio.protocol === Protocol.Local;
    }
  },

  [Filter.Network]: {
    label: Lang.protocol[Protocol.Network],
    matches({ audio }: Discovery$Audio): boolean {
      return audio.protocol === Protocol.Network;
    }
  }
});
